module.exports = __webpack_public_path__ + "static/cabina-de-conductor---grada-de-ingreso-8f2323f8e83f30049594a87abd4ab5b0.jpg";